import { ChevronDown } from "lucide-react";
import { useCollapse } from "@/lib/useCollapse";

// Collapsible card shell used across the Project Overview panels.
// Header (chevron + icon + title + count + optional actions) toggles the body;
// open/closed state is persisted per `id`.
export function SectionCard({ id, title, icon: Icon, count, actions, defaultOpen = true, testId, children }) {
    const [open, toggle] = useCollapse(`pr.sec.${id}`, defaultOpen);
    return (
        <div className="bg-white border rounded-[13px] shadow-brand-sm" style={{ borderColor: "#E5E0DA" }} data-testid={testId}>
            <div className="flex items-center justify-between gap-2 px-5 py-3.5">
                <button type="button" onClick={toggle} data-testid={testId ? `${testId}-toggle` : undefined}
                    className="flex items-center gap-2 text-[13px] font-bold text-[#1F1F1F] flex-1 min-w-0 text-left hover:opacity-80 transition-opacity">
                    <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform ${open ? "" : "-rotate-90"}`} style={{ color: "#9A968F" }} />
                    {Icon && <Icon className="w-4 h-4 flex-shrink-0" style={{ color: "var(--brand-accent,#C75A1B)" }} />}
                    <span className="truncate">{title}</span>
                    {count != null && <span className="text-[11px] font-normal flex-shrink-0" style={{ color: "#9A968F" }}>· {count}</span>}
                </button>
                {open && actions ? <div className="flex-shrink-0" onClick={(e) => e.stopPropagation()}>{actions}</div> : null}
            </div>
            {open && <div className="px-5 pb-5">{children}</div>}
        </div>
    );
}
